import { Component, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Curso } from '../../models/curso';
import { Participante } from '../../models/participante';
import { Antecedente, Antecedente_Emp } from '../../models/antecedente';
import { Envio } from '../../models/envio';
import { GenericRestService } from '../../services/http/generic-rest.service';
import {
  DEFAULT_TEMPLATE_STRUCTURE,
  TemplateStructure,
  TemplateStructureResponse
} from '../../models/template-structure';

@Component({
    selector: 'app-form',
    templateUrl: './form.component.html',
    styleUrls: ['./form.component.scss'],
    standalone: false
})
export class FormComponent implements OnInit {
  cursos_solicitados: Curso[] = [];
  participantes: Participante[] = [];
  antecedente: Antecedente = {
    name: '',
    email: '',
    cedula: '',
    celular: '',
    comuna: '',
    region: '',
    telefono: ''
  };
  antecedente_emp: Antecedente_Emp = {
    razon: '',
    email: '',
    direccion: '',
    celular: '',
    comuna: '',
    region: '',
    telefono: '',
    encargado: '',
    giro: '',
    rut: ''
  };

  templateStructure: TemplateStructure = { ...DEFAULT_TEMPLATE_STRUCTURE };
  loading = false;
  successDialogOpen = false;
  progressTitle = 'Procesando solicitud';
  progressMessage = 'Estamos comunicandonos con el servidor.';

  constructor(private http: GenericRestService) { }

  ngOnInit(): void {
    this.initdata();
    this.loadTemplateStructure();
  }

  private loadTemplateStructure(): void {
    this.showProgress('Cargando formulario', 'Preparando los campos disponibles.');
    this.http.getmail<TemplateStructureResponse>('template-structure').subscribe({
      next: response => {
        if (response?.templateStructure) {
          this.templateStructure = {
            ...DEFAULT_TEMPLATE_STRUCTURE,
            ...response.templateStructure
          };
        }
      },
      error: () => {
        this.templateStructure = { ...DEFAULT_TEMPLATE_STRUCTURE };
        this.hideProgress();
      },
      complete: () => {
        this.hideProgress();
      }
    });
  }

  private showProgress(title: string, message: string): void {
    this.progressTitle = title;
    this.progressMessage = message;
    this.loading = true;
  }

  private hideProgress(): void {
    this.loading = false;
  }

  initdata(): void {
    this.antecedente = { name: '', email: '', cedula: '', celular: '', comuna: '', region: '', telefono: '' };
    this.antecedente_emp = { razon: '', email: '', direccion: '', celular: '', comuna: '', region: '', telefono: '', encargado: '', giro: '', rut: '' };
    this.cursos_solicitados = [];
    this.participantes = [];
    const participante: Participante = { name: '', ci: '', curso: '', email: '', rol: '' };
    const curso: Curso = { nro: '1', personas: 0, curso: '' };
    this.participantes.push(participante);
    this.cursos_solicitados.push(curso);
  }

  addcurso(): void {
    const curso_actual = this.cursos_solicitados.length + 1;
    const curso: Curso = { nro: curso_actual.toString(), personas: 0, curso: '' };
    this.cursos_solicitados.push(curso);
  }

  addpart(): void {
    const participante: Participante = { name: '', ci: '', curso: '', email: '', rol: '' };
    this.participantes.push(participante);
  }

  delpart(): void {
    this.participantes.splice(-1);
  }

  delcurso(): void {
    this.cursos_solicitados.splice(-1);
  }

  customTrackBy(index: number): any {
    return index;
  }

  checkvalidemail(email: string): boolean {
    const filter = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;
    return String(email).search(filter) !== -1;
  }

  checkvalidant(): string[] {
    const errors: string[] = [];
    if (!this.templateStructure.mostrarAntecedentes) {
      return errors;
    }

    if (this.templateStructure.mostrarAntecedenteNombre && this.antecedente.name.trim().length === 0) {
      errors.push('El nombre en Antecedente es obligatorio');
    }

    if (this.templateStructure.mostrarAntecedenteComuna && this.antecedente.comuna.trim().length === 0) {
      errors.push('La comuna en Antecedente es obligatoria');
    }

    if (this.templateStructure.mostrarAntecedenteEmail) {
      if (this.antecedente.email.trim().length === 0) {
        errors.push('El correo en Antecedente es obligatorio');
      } else if (!this.checkvalidemail(this.antecedente.email)) {
        errors.push('El correo en Antecedente es invalido');
      }
    }

    return errors;
  }

  checkvalidantemp(): string[] {
    const errors: string[] = [];
    if (!this.templateStructure.mostrarAntecedentesEmpresa) {
      return errors;
    }

    if (this.templateStructure.mostrarEmpresaRut && this.antecedente_emp.rut.trim().length === 0) {
      errors.push('El RUT/RUC en Antecedente Empresa es obligatorio');
    }

    if (this.templateStructure.mostrarEmpresaRazon && this.antecedente_emp.razon.trim().length === 0) {
      errors.push('La razon social en Antecedente Empresa es obligatoria');
    }

    if (this.templateStructure.mostrarEmpresaGiro && this.antecedente_emp.giro.trim().length === 0) {
      errors.push('El giro en Antecedente Empresa es obligatorio');
    }

    if (this.templateStructure.mostrarEmpresaEncargado && this.antecedente_emp.encargado.trim().length === 0) {
      errors.push('El encargado en Antecedente Empresa es obligatorio');
    }

    if (this.templateStructure.mostrarEmpresaEmail) {
      if (this.antecedente_emp.email.trim().length === 0) {
        errors.push('El correo en Antecedente Empresa es obligatorio');
      } else if (!this.checkvalidemail(this.antecedente_emp.email)) {
        errors.push('El correo en Antecedente Empresa es invalido');
      }
    }

    return errors;
  }

  checkvalidcursos(): boolean {
    if (!this.templateStructure.mostrarCursos) {
      return true;
    }

    let valid = true;
    this.cursos_solicitados.forEach(curso => {
      if (this.templateStructure.mostrarCursoNro && curso.nro.trim().length === 0) {
        valid = false;
      }

      if (this.templateStructure.mostrarCursoNombre && curso.curso.trim().length === 0) {
        valid = false;
      }

      if (this.templateStructure.mostrarCursoPersonas && curso.personas == null) {
        valid = false;
      }
    });
    return valid;
  }

  checkvalidpart(): boolean {
    if (!this.templateStructure.mostrarParticipantes) {
      return true;
    }

    let valid = true;
    this.participantes.forEach(participante => {
      if (this.templateStructure.mostrarParticipanteNombre && participante.name.trim().length === 0) {
        valid = false;
      }

      if (this.templateStructure.mostrarParticipanteEmail) {
        if (participante.email.trim().length === 0 || !this.checkvalidemail(participante.email)) {
          valid = false;
        }
      }

      if (this.templateStructure.mostrarParticipanteCi && participante.ci.trim().length === 0) {
        valid = false;
      }

      if (this.templateStructure.mostrarParticipanteCurso && participante.curso.trim().length === 0) {
        valid = false;
      }
    });
    return valid;
  }

  send(): void {
    const errors = this.checkvalidant();
    const errors_emp = this.checkvalidantemp();
    const validcurso = this.checkvalidcursos();
    const validpart = this.checkvalidpart();

    if (errors.length > 0) {
      window.alert('Errores: ' + errors.join(', '));
      return;
    }
    if (errors_emp.length > 0) {
      window.alert('Errores: ' + errors_emp.join(', '));
      return;
    }
    if (!validcurso) {
      window.alert('Llene los campos obligatorios en cursos');
      return;
    }
    if (!validpart) {
      window.alert('Llene los campos obligatorios en participantes');
      return;
    }

    const envio: Envio = {
      nroinscripcion: '',
      antecedente: this.antecedente,
      antecedenteemp: this.antecedente_emp,
      cursos: this.cursos_solicitados,
      participantes: this.participantes,
      html: ''
    };

    this.showProgress('Enviando inscripcion', 'Registrando la solicitud y generando la confirmacion.');
    this.http.post<any>('api.php', envio).subscribe(
      data => {
        envio.nroinscripcion = data.nroinscripcion;
        this.progressTitle = 'Finalizando envio';
        this.progressMessage = 'Enviando la confirmacion por correo.';
        this.sendmail(envio)
          .then(() => {
            this.hideProgress();
            this.successDialogOpen = true;
          })
          .catch(() => {
            this.hideProgress();
            alert('Error en el envio');
          });
      },
      () => {
        this.hideProgress();
        alert('Error en el envio');
      }
    );
  }

  sendmail(envio: Envio): Promise<void> {
    return firstValueFrom(this.http.postmail<any>('samplepdf', envio)).then(() => undefined);
  }

  closeSuccessDialog(): void {
    this.successDialogOpen = false;
    this.initdata();
  }
}
